import { useState, useEffect, useRef } from "react";
// import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS, } from "../../../utils/const/estilos-const";
import { useTranslation } from "react-i18next";
import spinner from "../../../assets/iconos/spinner4.svg";
import readXlsxFile from "read-excel-file";
// import { INDEX_COLUMNAS_EXCEL } from "./concepto";

import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { STRING_COLOR_PRIMARIO } from "../../../utils/const/string-const";
import { COLOR_AZUL_MAIN, COLOR_ROJO } from "../../../utils/const/colors-const";
import shortid from "shortid";
// import moment from "moment";
import { exportarLink, sharedNextPage, sleep } from "../../../utils/shared-functions";
// import { obtenerListaEmpresaPlataforma } from "../../../api/api-empresa-plataforma";
import Select from "react-select";
// import { getListMarca } from "../../../api/api-marca";
import { obtenerConfiguracionExcelImportarVehiculo } from "../../../api/api-configuracion-importar-excel-vehiculo";
import { getListGrupo, getListGrupoByIdEmpresaPlataforma } from "../../../api/api-grupo";
import { getListSubGrupoCombo } from "../../../api/api-sub-grupo";
import PopUpLoadingComponent from "../../../components/pop-up-loading";
import { createVehiculoFromExcel } from "../../../api/api-vehiculo";
import { obtenerListaEmpresaPlataforma } from "../../../api/api-empresa-plataforma";

ModuleRegistry.registerModules([AllCommunityModule]);

export default function AdvanceVehiculo() {

    const { t } = useTranslation();

    const columnDefs = [
        {
            field: "acciones", headerName: t("column_actions"),
            cellRenderer: (params) => {
                // console.log('cellRenderer');
                // console.log(params);
                return (
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        <button
                            onClick={() => handleDelete(params.data)}
                            style={{
                                backgroundColor: COLOR_ROJO,
                                color: "white",
                                border: "none",
                                padding: "5px 10px",
                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                        >
                            {t("label_delete")}
                        </button>
                    </div >
                );
            }
        },
        { field: "id", headerName: "ID", hide: true },
        { field: "code", headerName: "CODE", filter: true, sortable: true, },
        { field: "licenceplate", headerName: "LICENCE PLATE", filter: true, sortable: true, },
        { field: "label", headerName: "LABEL", filter: true, sortable: true, },
        { field: "typevehicle", headerName: "TYPE VEHICLE", filter: true, sortable: true, },
        { field: "brand", headerName: "BRAND", filter: true, sortable: true, },
        { field: "model", headerName: "MODEL", filter: true, sortable: true, },
        { field: "year", headerName: "YEAR", filter: true, sortable: true, },
        { field: "fuel", headerName: "FUEL", filter: true, sortable: true, },
    ];

    // const history = useHistory();
    const [columnasExcelPersonal, setColumnasExcelPersonal] = useState(null);
    const columnasExcelPersonalRef = useRef(columnasExcelPersonal);
    // const dateInputRef = useRef(null);
    // const [fechaAdquisicion, setFechaAdquisicion] = useState("");
    const [loading, setLoading] = useState(false);

    const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);
    const [rowData, setRowData] = useState([]);

    const [listEmpresaPlataforma, setListEmpresaPlataforma] = useState([]);
    const [empresaPlataformaSelected, setEmpresaPlataformaSelected] = useState(null);


    const [listGrupo, setListGrupo] = useState([]);
    const [grupoSelected, setGrupoSelected] = useState(null);

    const [listSubGrupo, setListSubGrupo] = useState([]);
    const [subGrupoSelected, setSubGrupoSelected] = useState(null);

    const [popUpLoadingVisible, setPopUpLoadingVisible] = useState(false);
    const [messagePopUp, setMessagePopUp] = useState("");

    useEffect(() => {
        columnasExcelPersonalRef.current = columnasExcelPersonal;
    }, [columnasExcelPersonal]);

    useEffect(() => {
        try {
            const fileUpload = document.getElementById("fileUpload");
            fileUpload.addEventListener("change", () => {
                readXlsxFile(fileUpload.files[0]).then((rows) => {
                    reset();
                    procesarExcel(rows);
                    fileUpload.value = "";
                });
            });
            iniciar();
            const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
            if (mainColor !== null) {
                setPrimaryColor(mainColor);
            }
        } catch (e) {
            console.error(e.message);
        }
    }, []);

    const handleDelete = (data) => {
        try {
            const newRowData = rowData.filter((row) => row.id !== data.id);
            setRowData(newRowData);
        } catch (err) {
            console.log('handleDelete err');
            console.log(err);
        }
    };

    const iniciar = async () => {
        try {
            const resp = await obtenerConfiguracionExcelImportarVehiculo();
            if (resp.error === false && resp.body !== null) {
                setColumnasExcelPersonal(resp.body);
            }
            const empresaPlatafomra = await obtenerListaEmpresaPlataforma({ habilitado: 1 }, true, t);
            // console.log('empresaPlatafomra');
            // console.log(empresaPlatafomra);
            setListEmpresaPlataforma(empresaPlatafomra);
            const respGrupo = await getListGrupo({ habilitado: 1 }, true, t);
            // console.log('listEmpresas');
            // console.log(listEmpresas);
            setListGrupo(respGrupo);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    useEffect(() => {
        onChangeEmpresaPlataformaSelected();
    }, [empresaPlataformaSelected]);

    const onChangeEmpresaPlataformaSelected = async () => {
        setPopUpLoadingVisible(true);
        setListGrupo([]);
        setGrupoSelected(null);
        setListSubGrupo([]);
        setSubGrupoSelected(null);
        if (empresaPlataformaSelected !== null) {
            const grupo = await getListGrupoByIdEmpresaPlataforma({ idEmpresaPlataforma: empresaPlataformaSelected.value });
            setListGrupo(grupo);
        }
        setPopUpLoadingVisible(false);
    };

    useEffect(() => {
        onChangeGrupoSelected();
    }, [grupoSelected]);

    const onChangeGrupoSelected = async () => {
        setPopUpLoadingVisible(true);
        setListSubGrupo([]);
        setSubGrupoSelected(null);
        if (grupoSelected !== null) {
            const subGrupo = await getListSubGrupoCombo({ idGrupo: grupoSelected.value });
            setListSubGrupo(subGrupo);
        }
        setPopUpLoadingVisible(false);
    };

    const importar = () => {
        try {
            document.getElementById("fileUpload").click();
        } catch (err) {
            console.log("importarExcel err");
            console.log(err);
        }
    };

    const exportar = () => {
        try {
            const link =
                "https://gestion.boltrack.net/assets/template-import-vehiculo.xlsx";
            exportarLink(link, "template-import-vehiculo.xlsx");
        } catch (err) {
            console.log("importarExcel err");
            console.log(err);
        }
    };

    const handleAtrasClick = () => {
        // history.goBack();
        window.location.href = "/administer";
    };

    const reset = () => {
        try {
            setRowData([]);
        } catch (err) {
            console.log('reset err');
            console.log(err);
        }
    };

    const procesarExcel = (rows) => {
        try {
            // console.log('procesarExcel');
            // console.log(rows);
            // console.log('columnasExcelPersonalRef.current');
            // console.log(columnasExcelPersonalRef.current);
            if (rows.length === 0) {
                return [];
            }
            rows.shift();
            let indexCode = 0;
            let indexLicencePlate = 1;
            let indexLabel = 2;

            let indexTypeVehicle = 3;
            let indexBrand = 4;
            let indexModel = 5;

            let indexYear = 6;
            let indexFuel = 7;

            if (columnasExcelPersonalRef.current !== null) {
                indexCode = columnasExcelPersonalRef.current['indexCode'];
                indexLicencePlate = columnasExcelPersonalRef.current['indexLicencePlate'];
                indexLabel = columnasExcelPersonalRef.current['indexLabel'];
                indexTypeVehicle = columnasExcelPersonalRef.current['indexTypeVehicle'];
                indexBrand = columnasExcelPersonalRef.current['indexBrand'];
                indexModel = columnasExcelPersonalRef.current['indexModel'];
                indexYear = columnasExcelPersonalRef.current['indexYear'];
                indexFuel = columnasExcelPersonalRef.current['indexFuel'];
            }
            let data = [];
            for (let index = 0; index < rows.length; index++) {
                const element = rows[index];
                let obj = {};
                obj.id = shortid.generate();
                obj.code = element[indexCode] !== undefined ? element[indexCode] : null;
                obj.licenceplate = element[indexLicencePlate] !== undefined ? element[indexLicencePlate] : null;
                obj.label = element[indexLabel] !== undefined ? element[indexLabel] : null;

                obj.typevehicle = element[indexTypeVehicle] !== undefined ? element[indexTypeVehicle] : null;
                obj.brand = element[indexBrand] !== undefined ? element[indexBrand] : null;
                obj.model = element[indexModel] !== undefined ? element[indexModel] : null;

                obj.year = element[indexYear] !== undefined ? element[indexYear] : null;
                obj.fuel = element[indexFuel] !== undefined ? element[indexFuel] : null;
                data.push(obj);
            }
            setRowData(data);
        } catch (error) {
            console.log('procesarExcel err');
            console.log(error);
        }
    };

    const onCLickGuardar = async () => {
        try {
            setLoading(true);
            console.log(rowData);
            if (empresaPlataformaSelected === null) {
                alert(t("label_must_select_company"));
                setLoading(false);
                return;
            }
            if (grupoSelected === null) {
                alert(t("label_must_select_group"));
                setLoading(false);
                return;
            }
            if (subGrupoSelected === null) {
                alert(t("label_must_select_sub_group"));
                setLoading(false);
                return;
            }
            if (rowData.length === 0) {
                alert(t("label_error_empty_data"));
                setLoading(false);
                return;
            }
            const validRows = validateRows();
            if (validRows.error === true) {
                alert(validRows.message);
                setLoading(false);
                return;
            }
            const total = rowData.length;
            let allCorrect = true;
            setPopUpLoadingVisible(true);
            for (let i = 0; i < rowData.length; i++) {
                setMessagePopUp(i + 1 + "/" + total);
                const element = rowData[i];
                let objEnviar = {};
                objEnviar.idEmpresaPlataforma = empresaPlataformaSelected.value;
                objEnviar.codigo = element.code ?? "";
                objEnviar.placa = element.licenceplate;
                objEnviar.nombre = element.label;
                objEnviar.tipoVehiculo = element.typevehicle ?? "";
                objEnviar.marca = element.brand ?? "";
                objEnviar.modelo = element.model ?? "";
                objEnviar.tipoCombustible = element.fuel ?? "";
                objEnviar.idVoltajeBateria = 3;
                objEnviar.idTraccion = 3;
                objEnviar.anio = element.year;
                objEnviar.idGrupo = grupoSelected.value;
                objEnviar.idSubgrupo = subGrupoSelected.value;
                objEnviar.propietario = "";
                objEnviar.nroChasis = "";
                objEnviar.motor = "";
                objEnviar.cilindrada = 0;
                objEnviar.capacidadTanque = 0;
                objEnviar.capacidadCarga = 0;
                objEnviar.capacidadVolumen = 0;
                objEnviar.rendimientoKML = 0;
                objEnviar.colorIcono = 1;
                objEnviar.iconSelected = 2;
                objEnviar.colorVehiculo = "";

                const resp = await createVehiculoFromExcel(objEnviar);
                // console.log("resp", resp);
                if (resp.error === true) {
                    allCorrect = false;
                    alert(resp.message + "\n" + "Check if: " + element.licenceplate + "\nAlready exists");
                    break;
                }
                await sleep(200);
            }
            // const resp = await guardarImportarExcelVehiculo(objEnviar);
            // console.log("resp", resp);
            // if (resp.error === false) {
            //     alert(t('alert_created_success'));
            //     sharedNextPage("list-tipo-vehiculo", {}, history);
            // }
            // if (resp.error === true) {
            //     alert(resp.message);
            // }
            setPopUpLoadingVisible(false);
            setLoading(false);
            if (allCorrect === true) {
                alert(t("alert_created_success"));
            }
            if (allCorrect === false) {
                alert(t("alert_failed"));
            }
        } catch (err) {
            console.log('onCLickGuardar err');
            console.log(err);
            setLoading(false);
            setPopUpLoadingVisible(false);
        }
    };

    const validateRows = () => {
        try {
            let response = { error: true, message: "" };
            let message = "";
            for (let i = 0; i < rowData.length; i++) {
                const element = rowData[i];
                const placa = element.licenceplate;
                const nombre = element.label;
                if (placa === undefined || placa === null || String(placa).trim().length === 0) {
                    message = message + i + " - Licence Place cannot be empty \n";
                }
                if (nombre === undefined || nombre === null || String(nombre).trim().length === 0) {
                    message = message + i + " - Label cannot be empty \n";
                }
            }
            if (String(message).length > 0) {
                response.message = message;
                response.error = true;
            }
            if (String(message).length === 0) {
                response.error = false;
            }
            return response;
        } catch (err) {
            console.log('validateRows err');
            console.log(err);
            return { error: true };
        }
    };

    const render = () => {
        try {
            // if (cargandoPage === true) {
            //     return cargandoCard();
            // }
            return (
                <div className="p-4">
                    <div className="flex justify-between">
                        <label
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            {t("title_manage_import")}
                        </label>
                        <div className="flex justify-center">
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={(handleAtrasClick)}
                            >
                                {t("label_back")}
                            </button>
                        </div>
                    </div>
                    <br />
                    <div className="flex justify-between items-end gap-4">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                                    {t("label_select_company")}<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    options={listEmpresaPlataforma}
                                    isSearchable
                                    isClearable
                                    value={empresaPlataformaSelected}
                                    onChange={(event) => setEmpresaPlataformaSelected(event)}
                                    placeholder={t("label_select_company")}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                            <div class="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                                    {t("label_select_group")}<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    options={listGrupo}
                                    isSearchable
                                    isClearable
                                    value={grupoSelected}
                                    onChange={(event) => setGrupoSelected(event)}
                                    placeholder={t("label_select_group")}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                            <div class="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                                    {t("label_select_sub_group")}<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    options={listSubGrupo}
                                    isSearchable
                                    isClearable
                                    value={subGrupoSelected}
                                    onChange={(event) => setSubGrupoSelected(event)}
                                    placeholder={t("label_select_sub_group")}
                                    className="w-full"
                                    menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                />
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <button
                                className="bg-[#84B044] rounded text-white p-2 flex-none"
                                onClick={() => importar()}
                            >
                                IMPORTAR
                            </button>
                            <button
                                className="bg-[#84B044] rounded text-white p-2 flex-none"
                                onClick={() => exportar()}
                            >
                                EXPORTAR
                            </button>
                        </div>

                        <input
                            id="fileUpload"
                            type="file"
                            className="my-auto text-white p-[5px] px-[10px] mr-[10px] hidden"
                            accept=".xlsx,.xls"
                        />
                    </div>
                    <br />
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                            <div
                                className="ag-theme-alpine"
                                style={{
                                    height: "512px",
                                    width: "100%",
                                    "--ag-header-background-color": `${primaryColor}`,
                                }}
                            >
                                <AgGridReact
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    pagination={true}
                                    rowHeight={50}
                                />
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="flex justify-end">
                        {loading === false && (
                            <button
                                onClick={() => { onCLickGuardar(); }}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                GUARDAR
                            </button>
                        )}
                        {loading === true && (
                            <button className="login_button flex justify-center">
                                <img className="spinner"
                                    alt="spinner" src={spinner} />
                            </button>
                        )}
                    </div>
                    <PopUpLoadingComponent
                        isOpen={popUpLoadingVisible}
                        message={messagePopUp}
                    />
                </div>
            );
        } catch (err) {
            console.log('AdvanceMarca render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    };

    return render();
}